export const copyLink = {
    methods: {
        copyLink() {
            if (navigator.clipboard && window.isSecureContext) {
                navigator.clipboard.writeText(window.location.href)
                    .then(() => {
                        this.makeToast('success', 'Адрес скопирован');
                })
            } else {
                const textArea = document.createElement('textarea');
                textArea.value = window.location.href;

                textArea.style.position = 'absolute';
                textArea.style.left = '-999999px';

                document.body.prepend(textArea);
                textArea.select();

                try {
                    document.execCommand('copy');
                    this.makeToast('success', 'Адрес скопирован');
                } catch (error) {
                    console.error(error);
                } finally {
                    textArea.remove();
                }
            }
        },
    }
}
